import React from "react"

import styled from "styled-components"

export default () => {
  const companyData = [
    {
      name: "TryHard CREATIVE",
      katakana: "トライハードクリエイティブ",
      description:
        "DJ・DTMスクール運営から、アーティスト（DJ・MC）の育成やマネジメントにいたるまで、DJというアーティストの認知拡大・地位向上のため日々尽力しております。 スクールでは、キッズコースを設けるなど次世代を担う子供達へも「DJアーティスト」の浸透に努めると共に「夢へのプロセスを楽しむ」「日々成長する喜び」を共有できる場の提供を目指しております。 また、機材貸出設置・DJ出向、イベント構成の提案なども手がけ、全ての人の心に残るようなイベントの実現を心がけております。",
    },
    {
      name: "TryHard DINING",
      katakana: "トライハードダイニング",
      description:
        "芙蓉苑は四川料理の「文化」を大切に、お客様に「笑顔」を添えて「正真正銘、本物の四川料理の美味しさをお客様に提供する」をテーマに本場四川から特級料理人を招聘し、本格四川料理店を現在3店舗展開。神戸、京都など、関西圏を中心に店舗拡大を続けております。また食博、肉フェス等の食イベントにも積極的に参加、飲食というツールを通じて四川の豊かな文化を発信しております。",
    },
    {
      name: "TryHard MANAGEMENT",
      katakana: "トライハードマネジメント",
      description:
        "経理事務を代行する会社です。日次、月次で発生する記帳・仕訳業務や売掛金・買掛金管理、経費精算など経理業務全般を代行いたします。また経営資料・決算報告書などの作成サポートもいたします。",
    },
    {
      name: "TryHard TECH",
      katakana: "トライハードテック",
      description:
        "LEDパネル、演出照明、音響設備の販売・レンタル及びオペレーティングを承ります。各種イベント、展示会などの短期案件から、ナイトクラブやライブハウスなど店舗内で使用するシステム管理まで、高い技術力で幅広いシーンでのニーズにお応え致します。",
    },
  ]

  const companyListing = companyData.map(c => (
    <ListItem key={c.name}>
      <CompanyName>{c.name}</CompanyName>
      <CompanyKatakana>{c.katakana}</CompanyKatakana>
      <CompanyDescription>{c.description}</CompanyDescription>
    </ListItem>
  ))

  return (
    <>
      <List>{companyListing}</List>
    </>
  )
}

const List = styled.ul`
  grid-column: 2 / -2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 2rem 0 0;
  padding: 0;
  list-style: none;
`

const ListItem = styled.li`
  margin: 0 0 1rem;
  width: 100%;

  @media (min-width: 37.5em) {
    width: calc(50% - 1rem);
  }
`

const CompanyName = styled.h3`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 200;
`

const CompanyKatakana = styled.p`
  margin: 0;
  font-size: 0.825rem;
  font-weight: 200;
`

const CompanyDescription = styled.p`
  margin: 1rem 0 0;
  font-weight: 200;
`
